module.exports = "<div>\n  <h2>{{ 'maintenance.message' | translate }}</h2>\n  <p class=\"txtCenter imageError\">\n    <img class=\"sizeAjust\" src=\"img/photos/gamme.jpg\" width=\"934\" height=\"526\" alt=\"Gamme Renault\" />\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/maintenance/maintenance.html
// module id = 889
// module chunks = 0